import { gql } from "apollo-angular";
export const getUnreadNotificationsTask = gql`
  query unreadNotifications {
    unreadNotifications {
      id
      title
      sender
      senderId
      receiver
      receiverId
      dealId
      requestId
      type
      createdAt
      taskId
      read
      replied
    }
  }
`;
export const getUnrepliedNotificationsTask = gql`
  query unrepliedNotifications {
    unrepliedNotifications {
      id
      title
      sender
      senderId
      receiver
      receiverId
      dealId
      requestId
      type
      createdAt
      taskId
      read
      replied
    }
  }
`;
export const MarkNotifTaskAsRead = gql`
  mutation markNotificationsAsRead($notificationIds: [ID!]!) {
    markNotificationsAsRead(notificationIds: $notificationIds)
  }
`;
export const MarkNotifTaskAsReplied = gql`
  mutation markNotificationsAsReplied($notificationIds: [ID!]!) {
    markNotificationsAsReplied(notificationIds: $notificationIds)
  }
`;
